import { Box, Typography } from "@mui/material";
import React from "react";

const RectangleIcon = ({ color }) => (
  <div
    style={{
      width: "20px",
      height: "20px",
      backgroundColor: color || "gray",
      marginRight: "6px",
      border: "1px solid #ccc",
    }}
  ></div>
);

const LegendItem = ({ color, label }) => (
  <div
    style={{
      display: "flex",
      alignItems: "center",
      marginBottom: "6px",
      marginRight: "10px",
      fontSize: "14px",
    }}
  >
    <RectangleIcon color={color} />
    <span>{label}</span>
  </div>
);

const ChoroplethLegend = () => (
  <div
    style={{
      position: "absolute",
      bottom: "15px",
      left: "15px",
      zIndex: 1000,
      border: "1px solid #ddd",
      padding: "10px 13px",
      borderRadius: "8px",
      backgroundColor: "#ffffff",
      boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
      fontFamily: "Arial, sans-serif",
      maxWidth: "220px",
    }}
  >
    <h4
      style={{
        color: "#0190A0",
        marginTop: "0px",
        marginBottom: "12px",
        fontWeight: "bold",
        textAlign: "center",
      }}
    >
      CHOROPLETH
    </h4>

    <Box sx={{ display: "flex", flexDirection: "column" }}>
      <LegendItem color="#073956ff" label="> 1000" />
      <LegendItem color="#094d75ff" label="501 – 1000" />
      <LegendItem color="#0b5b89ff" label="251 – 500" />
      <LegendItem color="#237aacff" label="101 – 250" />
      <LegendItem color="#449ed2ff" label="76 – 100" />
      <LegendItem color="#62afdcff" label="51 – 75" />
      <LegendItem color="#90ccefff" label="11 – 50" />
      <LegendItem color="#f7fbff" label="0 – 10" />
    </Box>
  </div>
);

export default ChoroplethLegend;
